import React, { createContext, useContext, useState, useRef } from "react";
import { DeleteType, ConfirmDialogRef } from "../components/ConfirmDialog";

interface DialogContextType {
  importDialogOpen: boolean;
  editDialogOpen: boolean;
  confirmDialogOpen: boolean;
  setImportDialogOpen: (open: boolean) => void;
  setEditDialogOpen: (open: boolean) => void;
  setConfirmDialogOpen: (open: boolean) => void;
  confirmDialogRef: React.RefObject<ConfirmDialogRef | null>;
  deleteType: DeleteType;
  setDeleteType: (type: DeleteType) => void;
  nightToDelete: string | null;
  setNightToDelete: (night: string | null) => void;
  pendingDeleteTargetId: string | null;
  setPendingDeleteTargetId: (id: string | null) => void;
  pendingEditTargetId: string | null;
  setPendingEditTargetId: (id: string | null) => void;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const confirmDialogRef = useRef<ConfirmDialogRef | null>(null);
  const [deleteType, setDeleteType] = useState<DeleteType>(null);
  const [nightToDelete, setNightToDelete] = useState<string | null>(null);
  const [pendingDeleteTargetId, setPendingDeleteTargetId] = useState<
    string | null
  >(null);
  const [pendingEditTargetId, setPendingEditTargetId] = useState<string | null>(
    null
  );

  const wrappedSetDeleteType = (type: DeleteType) => {
    console.log("DialogContext: setDeleteType called with:", type);
    setDeleteType(type);
  };

  const value: DialogContextType = {
    importDialogOpen,
    editDialogOpen,
    confirmDialogOpen,
    setImportDialogOpen,
    setEditDialogOpen,
    setConfirmDialogOpen,
    confirmDialogRef,
    deleteType,
    setDeleteType: wrappedSetDeleteType,
    nightToDelete,
    setNightToDelete,
    pendingDeleteTargetId,
    setPendingDeleteTargetId,
    pendingEditTargetId,
    setPendingEditTargetId,
  };

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (context === undefined) {
    throw new Error("useDialog must be used within a DialogProvider");
  }
  return context;
};
